import BaseService from "./BaseService";

export default class ProductService extends BaseService {
    static resource() {
      return 'Products'
    }
}